import React from "react";

import Table from "../../common/Table";
import Option from "../../common/RowOption";

import { Link } from "react-router-dom";

const IncomesSubAccounts = ({ data, match, query }) => {
  const { tid, aid } = match.params;

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "name",
      label: "نام(فارسی)",
      content: (e) => (
        <Link
          to={`/mis/revenues/types/${tid}/accounts/${aid}/subAccounts/${e.id}/revenues`}
        >
          {e.name}
        </Link>
      ),
    },
    { path: "name_en", label: "نام(انگلیسی)" },
    { path: "budget", label: "بودجه" },
    { path: "received", label: "دریافت شده" },
    { path: "balance", label: "بیلانس" },
    {
      path: "option",
      content: (e) => (
        <Option
          Edit={{ form: "revenue-sub-account", cache: e.id, edit: e }}
          Delete={{ route: "revenues/subAccounts", id: e.id }}
        />
      ),
    },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default IncomesSubAccounts;
